import React, {Fragment} from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogAction from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import useMediaQuery from "@mui/material/useMediaQuery"
import {useTheme} from "@mui/material/styles"
import {List, ListItem} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { FULL_HALAL } from "../RequestRestaurant/halal_status"
import { setModalOpen, setModalRestaurant } from "../../redux/features/infoModal/infoModalSlice"
import { isRestaurantOpen } from "../../utils/isRestaurantOpen"


export const NewlyAddedRestaurants = ({open, handleClose}) => {
    const dispatch = useDispatch();
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
    let allRestaurants = useSelector(
        (state) => state.restaurantsReducer.restaurants
    )
    
    // Filter restaurants that have createdAt and sort by createdAt (largest timestamp first)
    const sortedRestaurants = [...allRestaurants]
        .filter(restaurant => restaurant.createdAt) // Only include restaurants with createdAt
        .sort((a, b) => b.createdAt - a.createdAt); // Descending order (newest first)
    
    const newlyAddedRestaurants = sortedRestaurants.slice(0, 100); // Limit to 100 restaurants

    const handleDialogClose = () => {
        handleClose()
    }

    const handleItemClick = (restaurant) => {
        dispatch(setModalRestaurant(restaurant));
        dispatch(setModalOpen(true));
    }

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleDialogClose}
                fullScreen={fullScreen}
                aria-labelledby="Newly-Added-dialog-title"
                maxWidth="lg" // Adjusted maxWidth here
            >
                <DialogTitle
                    id="Newly-Added-dialog-title"
                    sx={{
                        paddingTop: theme.spacing(2),
                        paddingBottom: theme.spacing(2),
                    }}
                >
                    <Typography variant="h6">Newly Added Restaurants</Typography>
                    <IconButton
                        sx={{
                            position: "absolute",
                            top: theme.spacing(1),
                            right: theme.spacing(1),
                        }}
                        onClick={handleDialogClose}
                    >
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>{" "}
                <DialogContent>
                    {newlyAddedRestaurants?.length > 0 ? (
                        <List sx={{position: 'relative'}}>
                            {newlyAddedRestaurants.map((restaurant, index) => {
                                let restaurantIsOpen = restaurant.currentOpeningHours ? isRestaurantOpen(restaurant.currentOpeningHours) : false;

                                return (
                                    <ListItem
                                        key={index}
                                        disablePadding
                                        sx={{
                                            padding: '0.5rem 0',
                                            "&:hover": {backgroundColor: "#f0f0f0"},
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        <Button
                                            fullWidth
                                            onClick={() => handleItemClick(restaurant)}
                                            startIcon={<RestaurantIcon/>}
                                            sx={{
                                                justifyContent: "flex-start",
                                                textTransform: "none",
                                                textAlign: "left",
                                                padding: "12px",
                                            }}
                                        >
                                            <Grid item container direction="column">
                                                <Typography
                                                    variant="body2"
                                                    style={{fontWeight: "bold", marginBottom: "4px"}}
                                                >
                                                    {restaurant.name}
                                                </Typography>
                                                <Typography style={{fontSize: "0.8rem", color: "#666"}}>
                                                    {restaurant.address}
                                                </Typography>
                                            </Grid>
                                            {restaurant.menu_status && (
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        fontSize: "0.8rem",
                                                        fontWeight: "bold",
                                                        color:
                                                            restaurant.menu_status === FULL_HALAL
                                                                ? "green"
                                                                : "orange",
                                                        marginLeft: "3rem",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {restaurant.menu_status === FULL_HALAL
                                                        ? "Full Halal"
                                                        : "Partial Halal"}
                                                </Typography>
                                            )}
                                            {(restaurant.currentOpeningHours && restaurant.currentOpeningHours.length > 0) && (
                                                <>
                                                    <Typography variant="body2"
                                                    style={{
                                                        fontSize: "0.8rem",
                                                        fontWeight: "bold",
                                                        color: restaurantIsOpen
                                                                ? "green"
                                                                : "red",
                                                        marginLeft: "3rem",
                                                        whiteSpace: "nowrap",
                                                    }}>
                                                        {restaurantIsOpen ? "Open" : "Closed"}
                                                    </Typography>
                                                    {(() => {
                                                        const now = new Date();
                                                        let currentDay = now.getDay(); // Sunday - Saturday : 0 - 6
                                                        let currentTime = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
                                                        if (currentDay === 0) currentDay = 6; // Convert Sunday to 6 for indexing
                                                        else currentDay -= 1; // Convert to 0-based index

                                                        if (currentTime <= 240) {
                                                            // If current time is before 4am and restaurant is open, show yesterday's closing time
                                                            currentDay = currentDay - 1;
                                                            if (currentDay === -1) currentDay = 6; // Convert Sunday to 6 for indexing
                                                        }

                                                        const openingHoursToday = restaurant.currentOpeningHours[currentDay];

                                                        if (!openingHoursToday) {
                                                            return null;
                                                        }

                                                        const [, hours] = openingHoursToday.split(": ");

                                                        return (
                                                        <Typography
                                                            sx={{
                                                            position: 'absolute',
                                                            bottom:'0rem',
                                                            right: '0.2rem',
                                                            fontSize: "0.8rem",
                                                            color: "#666",
                                                            textWrap: 'nowrap'}}
                                                            variant="paragraph">
                                                                {hours}
                                                            </Typography>
                                                        )
                                                    })()}
                                                </>
                                                )}
                                            {restaurant?.businessStatus === 'CLOSED_PERMANENTLY' && (
                                                <Typography variant="body2"
                                                style={{
                                                    fontSize: "0.8rem",
                                                    fontWeight: "bold",
                                                    color: "red",
                                                    marginLeft: "3rem",
                                                    whiteSpace: "nowrap",
                                                }}>
                                                    Permanently Closed
                                                </Typography>
                                            )}
                                            {restaurant?.businessStatus === 'CLOSED_TEMPORARILY' && (
                                                <Typography variant="body2"
                                                style={{
                                                    fontSize: "0.8rem",
                                                    fontWeight: "bold",
                                                    color: "red",
                                                    marginLeft: "3rem",
                                                    whiteSpace: "nowrap",
                                                }}>
                                                    Temporarily Closed
                                                </Typography>
                                            )}
                                        </Button>
                                    </ListItem>
                            )})}
                        </List>
                    ) : (
                        <Typography variant="body1">
                            No newly added restaurants found.
                        </Typography>
                    )
                    }
                </DialogContent>
                <DialogAction>
                    <Button
                        onClick={handleDialogClose}
                        color="primary"
                        variant="outlined"
                    >
                        Close
                    </Button>
                </DialogAction>
            </Dialog>
        </Fragment>
    )
}
